
const deepDefaults = (target, defaults) => {
  if(!target) target = {};
  var clone = JSON.parse(JSON.stringify(target));
  function run(clone, defaults) {
      const DEFAULTS_PROPERTY_NAMES = Object.getOwnPropertyNames(defaults);
      DEFAULTS_PROPERTY_NAMES.forEach(function (property) {
          if (Object.prototype.toString.call(defaults[property]) === "[object Object]") {
              if (!clone.hasOwnProperty(property)) {
                  clone[property] = {};
              }
              run(clone[property], defaults[property]);
          } else if (!clone.hasOwnProperty(property)) {
              clone[property] = defaults[property];
          }
      });
  }
  run(clone, defaults);
  return clone;
}

export default deepDefaults;


// WEBPACK FOOTER //
// ./src/pattern_utilities/deepDefaults.js